import Toastr from "../../../components/Toastr"
const parent = 'SETTING'

const DEFAULT_STATE = {
  templates: [],
  saving: false
}
let changes;
export default function templateReducer(state = DEFAULT_STATE, action){
  const response = action.payload && (action.payload.data || action.payload.response)
  switch(action.type){
    case `${parent}ORDER_TEMPLATE_LOAD_PENDING`:
      return {...state, saving: true};

    case `${parent}ORDER_TEMPLATE_LOAD_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return {...state,...changes};

    case `${parent}ORDER_TEMPLATE_LOAD_FULFILLED`:
    case `${parent}ORDER_TEMPLATE_LOAD`:
      changes = {
        templates: response.templates,
        saving: false
      }
      return {...state,...changes};

    case `${parent}ORDER_TEMPLATE_UPDATE_PENDING`:
      return {...state, saving: true};

    case `${parent}ORDER_TEMPLATE_UPDATE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return {...state,...changes};

    case `${parent}ORDER_TEMPLATE_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta && response.meta.message ? response.meta.message : "Updated successfully", 201)
      return { ...state, saving: false };

    default:
      return state;
  }
}
